<template>
    <validationErrorModal></validationErrorModal>
    <miniProfile></miniProfile>
    <dialogModal ref="dialogModal"></dialogModal>
    <admin-modal></admin-modal>
    <router-view v-show="!loading"></router-view>
    <div v-show="loading">
        <spinner></spinner>
    </div>
</template>
<script>


import cart from '../../store/cart';
import statistics from '../../store/statistics';
import navigation from '../../store/navigation';
import hash from '../../helper/hash';
import helper from '../../helper/helper';
import i18n from "../../language/i18n";

export default {
    provide() {
        return {navigation, cart, hash, helper,statistics}
    },
    computed: {},
    components: {
        validationErrorModal: require('../../components/modals/validation-error-modal').default,
        dialogModal: require('../../components/modals/dialog-modal').default,
        adminModal: require('../../components/modals/admin-modal').default,
        miniProfile: require('../../components/modals/profile').default,
    },
    name: 'app',
    data() {
        return {
            loading: false,
            data: false,
        }
    },
    watch: {
        $route(to, from) {
            if (to.name != undefined) {
                document.body.id = to.name + '-page';
            }
            if (this.$route.meta.title) {
                document.title = this.$route.meta.title;
            }
            this.nav();
        },

    },
    mounted() {
        emitter.on('pageNotFound',()=>{
            window.open("https://birchplace.com/trans/united-kingdom","_self");
        });
        app.config.globalProperties.$touch = window.$mobile;
        this.setScreenSize();
        window.addEventListener('resize', () => {
            this.setScreenSize();
        });
        emitter.on('loading', state => {
            console.log('loading', state)
            this.loading = state;
        });
        app.config.globalProperties.$dialog = (data) => {
            return this.$refs.dialogModal.show(data)
        }
        if ($userID) {
            setTimeout(()=>{
                $api.app.getData($userID,{path:this.$route.path,name:this.$route.name}).then(resp => {
                    this.data = resp.data;
                    if(resp.data.language != 'en'){
                        i18n.setLanguage(resp.data.language);
                    }
                    if (!resp.data.complete && resp.data.verify == undefined) {
                        this.$router.push('/edit/' + $userID + '?action=complete');
                    }
                });
            },500)

        }
    },
    beforeUnmount() {
        emitter.off('loading');
        emitter.off('pageNotFound');
    },
    methods: {
        nav() {
            let element = document.getElementById("top-nav");
            if (this.$route.meta.topNav) {
                element.classList.remove("container");
                element.classList.add("container-fluid");
            } else {
                element.classList.remove("container-fluid");
                element.classList.add('container');
            }
        },
        setScreenSize() {
            let screen = app.config.globalProperties.$screen = {
                width: window.innerWidth,
                height: window.innerHeight
            };
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                emitter.emit('screenSizeChanged', screen);
            }, 250);
        },
    }
}
</script>
<style lang="scss">
body, html {
    background: var(--bs-dark-white) !important;
    background-image: none !important;
}

.notification {
    z-index: 1050;
    position: fixed;
    right: 15px;
    top: 76px;
}

</style>
